import { IntegrationType } from 'helpers/integration/IntegrationType';
import { BaseIntegrationProps } from '../../BaseIntegrationProps';

export class ApricotIntegrationProps extends BaseIntegrationProps {

    private sessionId: string;
    protected integrationType = IntegrationType.Apricot;

    constructor(root: HTMLElement) {
        super(root);
        this.sessionId = this.getAttribute('REACT_APP_SESSION_ID', 'data-session-id');
    }
    getSessionHeaders(): { [key: string]: unknown; } {
        return {
            sessionid: this.sessionId
        };
    }
    getProductAdminType(): string {
        return 'administrator' ;
    }
    getMissingPropertyError(): Error | null {
        const error = super.getMissingPropertyError();
        if (error !== null) {
            return error;
        }
        if (!this.sessionId) {
            return new Error('Current Session ID is null');
        }
        return null;
    }
}
